import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Grid } from 'react-bootstrap';

import Header from './Header';
import Sidebar from './Sidebar';
import Dashboard from '../Pages/Dashboard';
import Footer from './Footer';
import { NotificationManager, notif } from '../Ui/Notification';
import Doctors, { WaitingDoctors } from '../Pages/Doctors';
import Tests, { TestsWaiting, TestsApproving } from '../Pages/Tests';
import TestDetail from '../Pages/TestDetail';

import DoctorProfile from '../Pages/DoctorProfile';
import Testers, { WaitingTesters } from '../Pages/Testers';
import TesterProfile from '../Pages/TesterProfile';
import withAuth from '../../Services/withAuth';
import AuthService from '../../Services/AuthService';

import Users from '../Pages/Users';
import UserProfile from '../Pages/UserProfile';
import { fetchApi } from '../../Network/NetworkService';
import dateFormat from 'dateformat';
import Requests from '../Pages/Requests';
import RequestDetails from '../Pages/RequestDetails';
import Pharmacy from '../Pages/Pharmacy';
import Notification from '../Pages/Notification';
import DoctorActive from '../Pages/DoctorActive';
import Pharmacist from '../Pages/Pharmacist';
import CustomerValue from '../Ui/CustomerValue';
import RequestAnalytics from '../Pages/RequestAnalytics';
import CohorteClients from '../Pages/CohorteClients';
import RecurrenceMedecins from '../Pages/RecurrenceMedecins';
import International from '../Pages/International';
import RechercheSymptomes from '../Pages/RechercheSymptomes';
import DoctorCancellations from '../Pages/DoctorCancellations';
import DoctorBehavior from '../Pages/DoctorBehavior';
import DoctorRefusalsDaily from '../Pages/DoctorRefusalsDaily';
import UserAnalytics from '../Ui/UserAnalytics';
import { TrackingIncomplete } from '../Ui/TrackingIncomplete';
import { TrackingWaiting } from '../Ui/TrackingWaiting';
import PrePharmacy from '../Pages/PrePharmacy';
import { CohortDoctor } from '../Ui/CohortDoctor';
import Newsletters from '../Pages/Newsletters';
import CampagneSdr from '../Pages/CampagneSdr';
import Acquisition from '../Pages/Acquisition';
import ConversionTunnel from '../Pages/ConversionTunnel';
import GoogleAdsPerformance from '../Pages/GoogleAdsPerformance';
import { TrackingCancel } from '../Ui/TrackingCancel';
import TrackingSuivi from '../Pages/TrackingSuivi';
import Feedback from '../Pages/Feedback';
import FeedbackDetails from '../Pages/FeedbackDetails';
import LTVClient from '../Pages/LTVClient';
import LTVClientOld from '../Pages/LTVClientOld';
import CustomerLTV from '../Pages/CustomerLTV';
import RecurrenceList from '../Pages/RecurrenceList';
import RelanceHistory from '../Pages/RelanceHistory';
import RelanceSuivi from '../Pages/RelanceSuivi';
import ReferralStats from '../Pages/ReferralStats';
import ABTests from '../Pages/ABTests';
import PaymentMethods from '../Pages/PaymentMethods';
import LeadCapital from '../Pages/LeadCapital';
import PendingCapture from '../Pages/PendingCapture';
import FollowupEmails from '../Pages/FollowupEmails';
import DermatoSdr from '../Pages/DermatoSdr';
import DermatoSdrHistory from '../Pages/DermatoSdrHistory';
import DermatoSdrCompletions from '../Pages/DermatoSdrCompletions';
import GdprWarning from '../Pages/GdprWarning';
import GdprWarningHistory from '../Pages/GdprWarningHistory';
import GdprReactivation from '../Pages/GdprReactivation';
import WhatsappOptin from '../Pages/WhatsappOptin';
import WhatsappOptinHistory from '../Pages/WhatsappOptinHistory';
import WhatsappOptinActivations from '../Pages/WhatsappOptinActivations';
import ReferralCampaign from '../Pages/ReferralCampaign';
import ReferralCampaignHistory from '../Pages/ReferralCampaignHistory';
import ReferralClicks from '../Pages/ReferralClicks';
import ReviewsWidgetSettings from '../Pages/ReviewsWidgetSettings';
import Subscriptions from '../Pages/Subscriptions';
import SubscriptionsAttribution from '../Pages/SubscriptionsAttribution';
import CancelStaleWaiting from '../Pages/CancelStaleWaiting';
import PricingConfig from '../Pages/PricingConfig';
import SuiviDermatoList from '../Pages/SuiviDermatoList';
import SuiviPathologieList from '../Pages/SuiviPathologieList';
import SuiviReconsultList from '../Pages/SuiviReconsultList';
import SuiviDermatoLink from '../Pages/SuiviDermatoLink';
import Signalements from '../Pages/Signalements';

class Layout extends React.Component {
    constructor() {
        super();

        this.state = {
            minHeight: 0,
            menuOpen: false
        };

        this.Auth = new AuthService();
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    toggleMenu() {
        this.setState(prevState => ({ menuOpen: !prevState.menuOpen }));
    }

    closeMenu() {
        this.setState({ menuOpen: false });
    }

    componentDidMount() {
        fetchApi(`/lastConnection`).then((res) => {
            if (res && res.user) {
                notif.addNotification(
                    'Dernière connexion',
                    res.user.username + ' a ' + dateFormat(res.user.login, 'dd/mm/yy HH:MM')
                );
            }
        }).catch(() => {
            // Silently ignore API errors
        });
    }

    render() {
        const profile = this.Auth.getProfile();
        const role = profile.role || 2;
        const { menuOpen } = this.state;
        return (
            <div>
                <Header history={this.props.history} onMenuToggle={this.toggleMenu} menuOpen={menuOpen} />
                <Sidebar role={role} isOpen={menuOpen} onClose={this.closeMenu} />
                <div
                    className="wrapper"
                    style={{ minHeight: '100vh' }}
                >
                    {
                        role === 5 ?
                        <div className="ctr">
                            <Grid>
                                <Switch>
                                    <Route
                                        exact
                                        path="/"
                                        component={() => <Dashboard role={role} utm_source={profile.utm_source} />}
                                    />
                                    <Route exact path="/requests/detail/:id" component={RequestDetails} />
                                    <Route exact path="/requests/:page?" component={() => <Requests match={this.props.match} history={this.props.history} role={role} utm_source={profile.utm_source} />} />

                                </Switch>
                            </Grid>
                        </div>
                        :
                        <div className="ctr">
                        <Switch>
                            <Route exact path="/analytics/cohorte-clients" component={() => <CohorteClients history={this.props.history} />} />
                            <Route exact path="/analytics/international" component={() => <International history={this.props.history} />} />
                            <Route>
                                <Grid>
                                    <Switch>
                                        <Route
                                            exact
                                            path="/"
                                            component={() => <Dashboard role={role} utm_source={profile.utm_source} />}
                                        />
                                        <Route
                                            exact
                                            path="/doctors/waiting"
                                            component={WaitingDoctors}
                                        />
                                        <Route exact path="/doctors/active" component={DoctorActive} />
                                        <Route exact path="/doctors/detail/:id" component={DoctorProfile} />
                                        <Route exact path="/users/detail/:id" component={UserProfile} />
                                        <Route exact path="/requests/detail/:id" component={RequestDetails} />
                                        <Route exact path="/requests-pending-capture" component={() => <PendingCapture history={this.props.history} />} />
                                        <Route exact path="/requests/cancel-stale-waiting" component={() => <CancelStaleWaiting history={this.props.history} />} />
                                        <Route exact path="/analytics/followup-emails" component={() => <FollowupEmails history={this.props.history} />} />
                                        <Route exact path="/subscriptions" component={() => <Subscriptions history={this.props.history} />} />
                                        <Route exact path="/subscriptions/attribution" component={() => <SubscriptionsAttribution history={this.props.history} />} />
                                        <Route exact path="/feedback" component={Feedback} />
                                        <Route exact path="/feedback/detail/:id" component={FeedbackDetails} />
                                        <Route exact path="/signalements" component={Signalements} />

                                        {/* <Route exact path="/feedback/detail/:id" component={feed} /> */}
                                        <Route
                                            exact
                                            path="/tests/toapproved"
                                            component={TestsApproving}
                                        />
                                        <Route exact path="/tests/:id" component={TestDetail} />
                                        <Route exact path="/testers" component={Testers} />
                                        <Route
                                            exact
                                            path="/testers/waiting"
                                            component={WaitingTesters}
                                        />
                                        <Route exact path="/campagne-sdr" component={CampagneSdr}  />
                                        <Route exact path="/dermato-sdr" component={() => <DermatoSdr history={this.props.history} />} />
                                        <Route exact path="/dermato-sdr/historique" component={() => <DermatoSdrHistory history={this.props.history} />} />
                                        <Route exact path="/dermato-sdr/completions" component={() => <DermatoSdrCompletions history={this.props.history} />} />
                                        <Route exact path="/gdpr-warning" component={() => <GdprWarning history={this.props.history} />} />
                                        <Route exact path="/gdpr-warning/historique" component={() => <GdprWarningHistory history={this.props.history} />} />
                                        <Route exact path="/gdpr-warning/reactivations" component={() => <GdprReactivation history={this.props.history} />} />
                                        <Route exact path="/whatsapp-optin" component={() => <WhatsappOptin history={this.props.history} />} />
                                        <Route exact path="/whatsapp-optin/historique" component={() => <WhatsappOptinHistory history={this.props.history} />} />
                                        <Route exact path="/whatsapp-optin/activations" component={() => <WhatsappOptinActivations history={this.props.history} />} />
                                        <Route exact path="/campagne-parrainage" component={() => <ReferralCampaign history={this.props.history} />} />
                                        <Route exact path="/campagne-parrainage/historique" component={() => <ReferralCampaignHistory history={this.props.history} />} />
                                        <Route exact path="/campagne-parrainage/clics" component={() => <ReferralClicks history={this.props.history} />} />
                                        <Route exact path="/site/avis" component={() => <ReviewsWidgetSettings history={this.props.history} />} />
                                        <Route exact path="/relance-history" component={RelanceHistory}  />
                                        <Route exact path="/relance-suivi" component={RelanceSuivi}  />
                                        <Route exact path="/referral-stats" component={ReferralStats}  />
                                        <Route exact path="/acquisition" component={Acquisition}  />
                                        <Route exact path="/suivi" component={() => <TrackingSuivi {...this.props}/>}  />
<Route exact path="/suivis/dermato" component={() => <SuiviDermatoList history={this.props.history} />}  />
<Route exact path="/suivis/pathologie" component={() => <SuiviPathologieList history={this.props.history} />}  />
<Route exact path="/suivis/reconsultation" component={() => <SuiviReconsultList history={this.props.history} />}  />
<Route exact path="/suivis/lien-whatsapp" component={() => <SuiviDermatoLink history={this.props.history} />}  />
                                        <Route exact path="/testers/:id" component={TesterProfile} />
                                        <Route exact path="/requests/:page?" component={() => <Requests match={this.props.match} history={this.props.history} role={role} utm_source={profile.utm_source} />} />
                                        <Route exact path="/doctors/:page?" component={Doctors} />
                                        <Route exact path="/users/:page?" component={Users} />
                                        <Route exact path="/pharmacy" component={Pharmacy} />
                                        <Route exact path="/pharmacy/pre-inscri" component={PrePharmacy} />
                                        <Route exact path="/notification" component={Notification} />
                                        <Route exact path="/lead-capital" component={LeadCapital} />
                                        <Route exact path="/pricing-config" component={PricingConfig} />
                                        <Route exact path="/newsletters" component={() => <Newsletters history={this.props.history} />} />
                                        <Route exact path="/pharmacist" component={Pharmacist} />
                                        <Route exact path="/analytics/request" component={() => <RequestAnalytics history={this.props.history} />} />
                                        <Route exact path="/analytics/user" component={() => <UserAnalytics history={this.props.history} />} />
                                        <Route exact path="/analytics/customer-value" component={() => <CustomerValue history={this.props.history} />} />
                                        <Route exact path="/analytics/recurrence-list" component={() => <RecurrenceList history={this.props.history} />} />
                                        <Route exact path="/analytics/recurrence-medecins" component={() => <RecurrenceMedecins history={this.props.history} />} />
                                        <Route exact path="/analytics/recherche-symptomes" component={() => <RechercheSymptomes history={this.props.history} />} />
                                        <Route exact path="/analytics/doctor-cancellations" component={() => <DoctorCancellations history={this.props.history} />} />
                                        <Route exact path="/analytics/doctor-behavior" component={() => <DoctorBehavior history={this.props.history} />} />
                                        <Route exact path="/analytics/doctor-refusals-daily" component={() => <DoctorRefusalsDaily history={this.props.history} />} />
                                        <Route exact path="/analytics/ltv" component={() => <LTVClient history={this.props.history} />} />
                                        <Route exact path="/analytics/ltv-old" component={() => <LTVClientOld history={this.props.history} />} />
                                        <Route exact path="/analytics/ltv-customer" component={() => <CustomerLTV history={this.props.history} />} />
                                        <Route exact path="/analytics/tracking-incomplete" component={() => <TrackingIncomplete history={this.props.history} />} />
                                        <Route exact path="/analytics/tracking-waiting" component={() => <TrackingWaiting history={this.props.history} />} />
                                        <Route exact path="/analytics/tracking-cancel" component={() => <TrackingCancel history={this.props.history} />} />
                                        <Route exact path="/analytics/doctor" component={() => <CohortDoctor history={this.props.history} />} />
                                        <Route exact path="/analytics/ab-tests" component={() => <ABTests history={this.props.history} />} />
                                        <Route exact path="/analytics/payment-methods" render={() => <PaymentMethods />} />
                                        <Route exact path="/conversion-tunnel" component={ConversionTunnel} />
                                        <Route exact path="/analytics/google-ads" component={GoogleAdsPerformance} />
                                    </Switch>
                                </Grid>
                            </Route>
                        </Switch>
                    </div>

                    }

                    <Footer />
                </div>
            </div>
        );
    }
}

export default withAuth(Layout);
